const COUNTER_FIELDS = [
  "operatingHours",
  "switchingCycles",
  "brakeApplication",
  "distance",
];

export const getWorstPartProgress = (parts) => {
  if (!parts?.length) return null;

  let worst = null;

  for (const part of parts) {
    if (part.eolIgnored || !part.endOfLife || !part.usageCounters?.length)
      continue;

    const latestCounter = part.usageCounters
      .slice()
      .sort((a, b) => new Date(b.timestampUtc) - new Date(a.timestampUtc))[0];

    for (const key of COUNTER_FIELDS) {
      const current = latestCounter[key];
      const limit = part.endOfLife[key];
      const offset = part.endOfLife[`${key}Offset`] ?? 0;

      if (current == null || !limit) continue;

      const progress = Math.min(
        Math.round(((current - offset) / limit) * 100),
        100
      );
      if (worst === null || progress > worst) worst = progress;
    }
  }

  return worst;
};

export const getWorstAssemblyProgress = (assemblies) => {
  if (!assemblies?.length) return null;

  let worst = null;

  for (const assembly of assemblies) {
    const progress = getWorstPartProgress(assembly.parts);
    if (progress !== null && (worst === null || progress > worst))
      worst = progress;
  }

  return worst;
};

export const getWorstPosProgress = (locations, pos) => {
  const assemblies = locations
    .filter((l) => l.pos === pos)
    .flatMap((l) => l.assemblies);
  return getWorstAssemblyProgress(assemblies);
};

export const getWorstLacProgress = (locations, lac) => {
  const assemblies = locations
    .filter((l) => l.lac === lac)
    .flatMap((l) => l.assemblies);
  return getWorstAssemblyProgress(assemblies);
};